import { InteractionType } from '@azure/msal-browser'
import { environment } from '@appEnvironments/environment'

const apiConfig = environment.apiConfig
const authorityDomain = apiConfig.authorityDomain

//TODO: Leo - tenant?
export const B2C_TENANT = 'swfcb2c.onmicrosoft.com'
export const B2C_Authority_URL = `https://${authorityDomain}/${B2C_TENANT}`

export enum B2CAuthority_ {
   defaultSignUpSignIn = 'defaultSignUpSignIn'
}

export interface b2cAuthority {
   authority: string
}

const userFlows = apiConfig.userFlows

export const b2cAuthorities = new Map<B2CAuthority_, b2cAuthority>([
   [B2CAuthority_.defaultSignUpSignIn, {
      authority: `${B2C_Authority_URL}/${userFlows.defaultSignUpSignIn}`
   }]
])

export const defaultSignUpSignInAuthority = b2cAuthorities.get(B2CAuthority_.defaultSignUpSignIn)
export const defaultB2CAuthority: b2cAuthority = defaultSignUpSignInAuthority

export const b2cPolicies = {
   names: {
      defaultSignIn: B2CAuthority_.defaultSignUpSignIn
   },
   authorities: {
      [B2CAuthority_.defaultSignUpSignIn]: defaultSignUpSignInAuthority
   },
   authorityDomain: authorityDomain
}

export const b2cInteractionType = InteractionType.Redirect
